export default __webpack_public_path__ + "static/media/charity-coins.a01182c8.png";